import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import type { BankDetailsFindInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank-details-find.dto';
import { BasisClientService } from '@zaoblako/web/core/services/basis/basis-client.service';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';
import { HighlightMatchTextHelper } from '@zaoblako/web/shared/helpers/highlight-match-text.helper';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';

@Component({
  selector: 'crm-bank-details-auto-complete',
  standalone: true,
  imports: [CommonModule, AutoCompleteComponent, SafeHtmlPipe],
  templateUrl: './bank-details-auto-complete.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankDetailsAutoCompleteComponent {
  @ViewChild('bankDetailAutoComplete', { static: true }) public bankDetailAutoComplete: AutoCompleteComponent;

  @Input() public selectedBankDetail: BankDetailsFindInterface;
  @Output() public selectedBankDetailChange = new EventEmitter<BankDetailsFindInterface>();

  @Input() public bankDetails: BankDetailsFindInterface[] = [];
  @Input() public isError = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public inputStyle: any;
  @Input() public inputStyleClass: string;
  @Input() public placeholder: string;
  @Input() public disabled = false;
  @Input() public appendTo: string;

  @Input() public customSearch = true;

  @Output() public bankDetailsSearch = new EventEmitter<string>();

  public constructor(
    private readonly basisClientService: BasisClientService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public toBankDetail(bankDetail: any): BankDetailsFindInterface {
    return bankDetail as BankDetailsFindInterface;
  }

  public searchBankDetails(search: string) {
    this.basisClientService.bankDetailsSearch({ search }).subscribe((bankDetails) => {
      this.bankDetails = bankDetails;
      this.cdRef.markForCheck();
    });
  }

  public highlightMatchText(text: string): string {
    return HighlightMatchTextHelper.highlightMatchText(text, this.bankDetailAutoComplete?.autoComplete?.inputValue());
  }
}
